import {process24Hour,addZero,dateToTimeObj,condensedTimeRange} from '../../util/datetime'
import useCurrentUser from '../../hooks/useCurrentUser'
import Badge from 'react-bootstrap/Badge'
import moment from 'moment'

import {useSetEditor} from './hooks'

import {useGymTrainers,useClients} from '../users/hooks'

import css from './Styles.module.css'

const Event = ({event,is24HourTime}) => {

	const {start,end,title} = event
	const user = useCurrentUser()

	const trainers = event.trainers


	console.log('Event',event)

	const {clients} = useClients()

	const clientNames = clients
		.filter(({user_id_number})=>event.client_id_arr.includes(user_id_number))
		.map(({user_name})=>user_name)
		.join(', ')

    const isRecurring = (
		event?.recurrence_type !== ''
		&& event?.recurrence_type !== 'none'
	)

	const fontSize = 12

	const isGroupSession = event.event_type === 'group_session' || event.event_type === 'semi_private'
	const isParticipant = event.client_ids?.includes(user.user_id_number)
	const numParticipants = event.client_ids?.split(',').filter(Boolean).length

	const groupSessionSize = event.group_session_size

	const setEditor = useSetEditor()
	const handleEdit = e=>{
		e.stopPropagation()
		setEditor({
			show:true,
			id:event.id,
			editSeries:isRecurring?0:1
		})
	}

	return (
		<div style={{
			width:'100%',
			overflow:'auto',
			height:'100%'
		}}>
			<div className="EventOptions">
				<button 
					style={{
						background:'transparent',
						border:'none',
						textAlign:'left',
						padding:'0',
						marginRight:'4px'
					}}
					onClick={handleEdit}
				>
					Edit <i className="fa fa-edit"/>
				</button>
			</div>
			<div style={{
				height:'100%',
				overflow:'hidden'
			}}>
				{(isGroupSession&&isParticipant)&&
					<i
						className="fas fa-user-check text-white mr-1 mb-1"
						style={{fontSize:'14px'}}
					/>
				}
				<small style={{fontWeight:'bold',fontSize}}>
					{
						event.event_type === 'closed'
						? 'Closed'
						: title
					}
				</small>
				<small style={{fontSize}} className="ml-1">
					{
						is24HourTime
						? `${moment(start).format("HH:mm")} - ${moment(end).format("HH:mm")}`
						: condensedTimeRange(start,end)
					}
				</small>
				{trainers.length>0&&
					<small className="d-block mt-1" style={{fontSize}}>
						<i className="fa fa-user"/> {trainers.map(({user_name})=>user_name).join(', ')}
					</small>
				}
				{Boolean(event.event_type==='notes')&&
					<div className="mt-1">
						{event.body}
					</div>
				}
				{(isGroupSession&&!isParticipant&&!isNaN(numParticipants)&&groupSessionSize)&&
					<small className="d-block mt-1">
						{groupSessionSize - numParticipants} spots left
					</small>
				}
				{Boolean(clientNames)&&
					<small style={{fontSize}}>
						<i className="fa fa-users"/> {clientNames}
					</small>
				}
			</div>
		</div>
	)
}

export default Event